const LOCALE_PATTERN = /^[a-z]{2,3}(?:-[a-z0-9]{2,8})*$/;

export function normalizeAuthoringLocale(value: string): string | null {
  const normalized = value.trim().replace(/_/g, '-').toLowerCase();
  return LOCALE_PATTERN.test(normalized) ? normalized : null;
}
